
export const ShortCutItems = [
    {
        id: 1,
        imgSrc: '/img/frost.png',
        text: 'Chill Hits'
    },
    {
        id: 2,
        imgSrc: '/img/star.png',
        text: 'Hop'
    },
    {
        id: 3,
        imgSrc: '/img/electric-guitar.png',
        text: 'Accoustic'
    },
    {
        id: 4,
        imgSrc: '/img/music.png',
        text: 'Indie Pop'
    },
    {
        id: 5,
        imgSrc: '/img/piano.png',
        text: 'Piano Blues'
    },
    {
        id: 6,
        imgSrc: '/img/saxophone.png',
        text: 'Jazz'
    },
]